import { useSelector } from 'react-redux';
// import React from 'react';
import PropTypes from 'prop-types';
// import { Redirect } from 'react-router-dom';

function AuthGuard({ children }) {
  const account = useSelector((state) => state.account);

  if (!account.user) {
    window.location.href = '/login';
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthGuard;
